"use client"

import { useDialog } from '@/contexts/dialog-context'
import MultistepFormDialog from '@/components/ui/multistep-form-dialog'

export default function DialogManager() {
  const { isDialogOpen, closeDialog } = useDialog()

  return (
    <MultistepFormDialog 
      isOpen={isDialogOpen} 
      onOpenChange={closeDialog} 
    />
  )
}